/**
 * NOTE: See helpers.getPlatform for how these are used and some more notes on
 *       what we mean by 'platform'.
 */

export const SUPPORTED_PLATFORMS = ["insights", "visor"] as const;

export type SupportedPlatform = typeof SUPPORTED_PLATFORMS[number];

export const DEFAULT_PLATFORM: SupportedPlatform = "insights";

export const DOMAIN_TO_PLATFORM_MAPPING: Record<string, SupportedPlatform> = {
  "visor.ag": "visor",
  "insights.ag": "insights",
  localhost: DEFAULT_PLATFORM,
} as const;
